export default __webpack_public_path__ + "static/media/smh.0baf1168.gif";